"use client";
import React, { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { COOKIE_CONSENT_EVENT, readCookieConsent } from "@/lib/cookie-consent";

export const FacebookPixelEvents: React.FC = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const [marketing, setMarketing] = React.useState(false);

  useEffect(() => {
    setMarketing(Boolean(readCookieConsent()?.marketing));
    const onChange = (event: Event) =>
      setMarketing(Boolean((event as CustomEvent<{ marketing: boolean }>).detail?.marketing));
    window.addEventListener(COOKIE_CONSENT_EVENT, onChange as EventListener);
    return () => window.removeEventListener(COOKIE_CONSENT_EVENT, onChange as EventListener);
  }, []);

  useEffect(() => {
    // Meta Pixel only runs with marketing consent from the cookie banner.
    if (!marketing) return;
    import("react-facebook-pixel")
      .then((x) => x.default)
      .then((ReactPixel) => {
        ReactPixel.init("1769105956830922");
        ReactPixel.pageView();
      });
  }, [marketing, pathname, searchParams]);

  return null;
};
